import styled, { css } from 'styled-components';
import { mediaQuery } from '~/src/styles/mixins';
import { MAX_767, MAX_1279, MAX_1439, MAX_1679, MAX_1919, MIN_1920 } from '~/src/styles/tokens/break-points';
import { rem } from '~/src/helpers/rem-converter.helper';
import { COLORS } from '~/src/styles/tokens/colors';

export const ContainerLayout = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding: ${rem(60)} ${rem(175)} ${rem(120)};
    position: relative;
    background: ${COLORS.backgroundLightSecondary};

    ${mediaQuery(
        { minWidth: MIN_1920 },
        css`
            padding: ${rem(40)} 0 ${rem(120)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1919 },
        css`
            padding: ${rem(60)} ${rem(160)} ${rem(120)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1679 },
        css`
            padding: ${rem(40)} ${rem(88)} ${rem(120)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1439 },
        css`
            padding: ${rem(40)} ${rem(56)} ${rem(120)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            padding: 0 0 ${rem(120)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            padding: 0 0 ${rem(120)};
        `,
    )};
`;

export const ContentContainerAgencyProductBanner = styled.section`
    margin-bottom: ${rem(60)};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            margin-bottom: ${rem(40)};
        `,
    )};
`;

export const ContentContainerProductGroups = styled.section`
    display: flex;
    gap: ${rem(32)};
    margin: 0 auto;
    max-width: ${rem(1552)};
    width: 100%;

    ${mediaQuery(
        { maxWidth: MAX_1919 },
        css`
            max-width: ${rem(1599)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            padding: 0 ${rem(40)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            padding: 0 ${rem(20)};
        `,
    )};
`;

export const ColumnProductGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(24)};
    width: 100%;
    height: fit-content;
	
	${mediaQuery(
        { minWidth: MIN_1920 },
        css`
	        gap: ${rem(32)};
        `,
    )};
`;
